import React from "react";
import styled, { keyframes } from "styled-components";
import colgateLogo from "../media/img/colgateLogobb.png";
import amfamLogo from "../media/img/amfamLogobb.png";
import palmoliveLogo from "../media/img/palmoliveLogobb.png";
import seacretLogo from "../media/img/seacretLogobb.png";
import classDojLogo from "../media/img/classDojLogobbW.png";
import impactiveLogo from "../media/img/impactivebb.png";
import bioplusLogo from "../media/img/bioplusLogobb.png";
import pmInterLogo from "../media/img/pmInterbb.png";
import socialrootsLogo from "../media/img/socialrootsbb.png";
import elevateHTLogo from "../media/img/elevateHTbb.png";
import patternAgLogo from "../media/img/patternAgbb.png";
import zinzinoLogo from "../media/img/zinzinoLogobb.png";

// Subtle float animation for logos
const float = keyframes`
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-5px) scale(1.05);
  }
`;

// Seamless infinite scroll animation but in opposite direction
const scrollInfiniteReverse = keyframes`
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
`;

// Shine effect animation
const shine = keyframes`
  0% {
    background-position: -200px;
  }
  100% {
    background-position: 400px;
  }
`;

const StripContainer = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background: linear-gradient(90deg, 
    rgba(26, 149, 201, 0.05), 
    rgba(26, 149, 201, 0.1),
    rgba(57, 185, 239, 0.15),
    rgba(26, 149, 201, 0.1),
    rgba(26, 149, 201, 0.05)
  );
  border-top: 1px solid rgba(26, 149, 201, 0.15);
  border-bottom: 1px solid rgba(26, 149, 201, 0.15);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  padding: 30px 0;
  position: relative;
  margin: 0 0 60px 0;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, 
      rgba(255, 255, 255, 0) 0%, 
      rgba(255, 255, 255, 0.05) 25%, 
      rgba(255, 255, 255, 0.1) 50%, 
      rgba(255, 255, 255, 0.05) 75%, 
      rgba(255, 255, 255, 0) 100%);
    animation: ${shine} 8s linear infinite;
    pointer-events: none;
  }
  
  @media (max-width: 768px) {
    padding: 20px 0;
    margin: 0 0 40px 0;
  }
`;

const TitleBar = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const StripTitle = styled.h3`
  font-size: 1.2rem;
  color: rgba(26, 149, 201, 0.8);
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0;
`;

// This wrapper contains the duplicate set of logos for seamless scrolling
const InfiniteLogoTrack = styled.div`
  display: inline-block;
  white-space: nowrap;
  animation: ${scrollInfiniteReverse} 45s linear infinite;
  will-change: transform;
`;

const LogoContainer = styled.div`
  display: inline-block;
  position: relative;
  margin: 0 25px;
  vertical-align: middle;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.15) translateY(-5px);
    z-index: 2;
  }
`;

const Logo = styled.img`
  height: 55px;
  filter: brightness(0.5) grayscale(70%);
  transition: all 0.3s ease;
  animation: ${float} 3s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;
  
  ${LogoContainer}:hover & {
    filter: brightness(1) grayscale(0%);
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    height: 45px;
  }

  @media (max-width: 480px) {
    height: 35px;
  }
`;

const logos = [
  colgateLogo,
  amfamLogo,
  palmoliveLogo,
  seacretLogo,
  classDojLogo,
  impactiveLogo,
  bioplusLogo,
  pmInterLogo,
  socialrootsLogo,
  elevateHTLogo,
  patternAgLogo,
  zinzinoLogo,
];

const SoftwareTopLogoStrip = () => {
  // Create a component with duplicate logo sets for seamless infinite scrolling
  const renderLogos = (isSecondSet = false) => {
    return logos.map((logo, index) => (
      <LogoContainer key={`${isSecondSet ? 'dup-' : ''}${index}`}>
        <Logo 
          src={logo} 
          alt={`Client Logo ${index + 1}`}
          delay={(index * 0.2) % 2} 
        />
      </LogoContainer>
    ));
  };

  return (
    <StripContainer>
      <TitleBar>
        <StripTitle>Trusted By Industry Leaders</StripTitle>
      </TitleBar>
      <InfiniteLogoTrack>
        {renderLogos()}
        {renderLogos(true)}
      </InfiniteLogoTrack>
    </StripContainer>
  );
};

export default SoftwareTopLogoStrip; 